import React from 'react';

import { useSearchParams } from 'react-router-dom';

type FilterKey = 'status' | 'recipient' | 'sender';

export const useWarehouseDocumentSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchValue = searchParams.get('q') || '';
  const statusValue = searchParams.getAll('status');
  const recipientValue = searchParams.getAll('recipient');
  const senderValue = searchParams.getAll('sender');
  const [searchInputValue, setSearchInputValue] = React.useState(searchValue);

  React.useEffect(() => {
    setSearchInputValue(searchValue);
  }, [searchValue]);

  const handleSearch = (value: string) => {
    const nextUrl = new URLSearchParams(searchParams);

    if (value) {
      nextUrl.set('q', value);
    } else {
      nextUrl.delete('q');
    }

    nextUrl.set('current', '1');
    setSearchParams(nextUrl);
  };

  const handleFilterChange = (key: FilterKey, value: string[]) => {
    const nextUrl = new URLSearchParams(searchParams);

    nextUrl.delete(key);

    value.forEach((item) => {
      nextUrl.append(key, item);
    });

    nextUrl.set('current', '1');
    setSearchParams(nextUrl);
  };

  const handleReset = () => {
    const nextUrl = new URLSearchParams(searchParams);

    nextUrl.delete('q');
    nextUrl.delete('status');
    nextUrl.delete('recipient');
    nextUrl.delete('sender');
    nextUrl.set('current', '1');

    setSearchInputValue('');
    setSearchParams(nextUrl);
  };

  return {
    searchInputValue,
    searchValue,
    recipientValue,
    senderValue,
    statusValue,
    handleRecipientChange: (value: string[]) => handleFilterChange('recipient', value),
    handleReset,
    handleSearch,
    handleSenderChange: (value: string[]) => handleFilterChange('sender', value),
    handleStatusChange: (value: string[]) => handleFilterChange('status', value),
    setSearchInputValue,
  };
};
